/* eslint-disable @typescript-eslint/no-explicit-any */
import {SelectItem} from 'primeng/api';

export enum ERestriction {
  Required = 'required',
  MinLength = 'minLength',
  MaxLength = 'maxLength',
  Min = 'min',
  Max = 'max',
  Pattern = 'pattern',
  Email = 'email',
  MinDate = 'minDate',
  MaxDate = 'maxDate',
  Custom = 'custom',
  BloodGroup = 'bloodGroup',
  NumberOfFetusesMulti = 'numberOfFetusesMulti',
}

export enum EDynamicFormFieldType {
  InputText = 'InputText',
  InputNumber = 'InputNumber',
  InputGroup = 'InputGroup',
  InputGroupAddon = 'InputGroupAddon',
  Accordion = 'Accordion',
  AccordionTab = 'AccordionTab',
  VariableAccordion = 'VariableAccordion',
  VariableAccordionTab = 'VariableAccordionTab',
  Textarea = 'Textarea',
  Select = 'Select',
  MultiSelect = 'MultiSelect',
  RadioButton = 'RadioButton',
  Checkbox = 'Checkbox',
  Date = 'Date',
  HtmlTag = 'HtmlTag',
}

export enum EDirection {
  Horizontal = 'Horizontal',
  Vertical = 'Vertical',
}

export enum EConditionType {
  Show = 'show',
  Hide = 'hide',
  Enable = 'enable',
  Disable = 'disable',
  Required = 'required',
  Optional = 'optional',
  Pattern = 'pattern',
}

export interface IDynamicFormOption extends SelectItem {
  tooltip?: string;
  selected?: boolean;
}

export interface IDynamicFormFieldCondition {
  type: EConditionType;
  value: string;
  targetFieldName: string;
}

export interface IDynamicFormFieldValidator {
  restriction: ERestriction;
  value?: string;
  format?: string;
}

export interface IDynamicFormField {
  type: EDynamicFormFieldType;
  name: string;
  label: string;
  labelTop?: boolean;
  labelColSize?: number;
  colSize?: number;
  placeholder?: string;
  styleClass?: string;
  disabled?: boolean;
  hidden?: boolean;
  validators?: IDynamicFormFieldValidator[];
  conditions?: IDynamicFormFieldCondition[];
}

export interface IDynamicFormInputText extends IDynamicFormField {
  value?: string | null;
}
export interface IDynamicFormInputNumber extends IDynamicFormField {
  value?: number | null;
  min?: number | null;
  max?: number | null;
  step?: number | null;
}
export interface IDynamicFormInputGroup extends IDynamicFormField {
  value?: string | null;
  fields: IDynamicFormField[];
}
export interface IDynamicFormAccordion extends IDynamicFormField {
  value?: string | null;
  fields: IDynamicFormField[];
}
export interface IDynamicFormAccordionTab extends IDynamicFormField {
  value?: string | null;
  fields: IDynamicFormField[];
  expanded?: boolean | null;
}
export interface IDynamicFormVariableAccordion extends IDynamicFormField {
  min?: number | null;
  max?: number | null;
  value?: number | null;
  fields: IDynamicFormField[];
}
export interface IDynamicFormVariableAccordionTab extends IDynamicFormField {
  value?: number | null;
  fields: IDynamicFormField[];
  expanded?: boolean | null;
}
export interface IDynamicFormTextarea extends IDynamicFormField {
  value?: string | null;
  rows?: number | null;
  cols?: number | null;
}
export interface IDynamicFormSelect extends IDynamicFormField {
  value?: any[] | null;
  options?: any[];
  optionLabel?: string;
  optionValue?: string;
  optionLabelsExcluded?: string;
  showValueInLabel?: boolean;
  showFilter?: boolean;
  filterAtClient?: boolean;
  filterBy?: string;
  filterFields?: any[];
  filterValue?: string;
  filterDefaultValue?: string;
  lazy?: boolean;
  apiEndpointUrl?: string;
  pageSize?: number;
  pageNumber?: number;
  filterPlaceHolder?: string;
  loadingPlaceHolder?: string;
}
export interface IDynamicFormMultiSelect extends IDynamicFormField {
  value?: any[] | null;
  options?: any[];
  optionLabel?: string;
  optionValue?: string;
  optionLabelsExcluded?: string;
  showValueInLabel?: boolean;
  display?: 'comma' | 'chip';
  showToggleAll?: boolean;
  showFilter?: boolean;
  filterAtClient?: boolean;
  filterBy?: string;
  filterFields?: any[];
  filterValue?: string;
  filterDefaultValue?: string;
  lazy?: boolean;
  apiEndpointUrl?: string;
  pageSize?: number;
  pageNumber?: number;
  filterPlaceHolder?: string;
  loadingPlaceHolder?: string;
}
export interface IDynamicFormRadioButton extends IDynamicFormField {
  value?: IDynamicFormOption | null;
  direction?: EDirection | null;
  options?: IDynamicFormOption[] | null;
}
export interface IDynamicFormCheckbox extends IDynamicFormField {
  value?: IDynamicFormOption | null;
  direction?: EDirection | null;
  options?: IDynamicFormOption[] | null;
}
export interface IDynamicFormDate extends IDynamicFormField {
  value?: Date | null;
  format?: string;
}

export type IDynamicFormFieldType =
  | IDynamicFormInputText
  | IDynamicFormInputNumber
  | IDynamicFormInputGroup
  | IDynamicFormAccordion
  | IDynamicFormAccordionTab
  | IDynamicFormVariableAccordion
  | IDynamicFormVariableAccordionTab
  | IDynamicFormTextarea
  | IDynamicFormSelect
  | IDynamicFormMultiSelect
  | IDynamicFormRadioButton
  | IDynamicFormCheckbox
  | IDynamicFormDate;
